import type React from 'react';

import classes from './Details.module.scss';
import { DetailsTask } from './DetailsTask/DetailsTask';
import { DetailsTaskNew } from './DetailsTaskNew/DetailsTask';

export const Details: React.FC = () => {
  return (
    <div className={classes.container}>
      <DetailsTask />
    </div>
  );
};

export const DetailsNew: React.FC = () => {
  return (
    <div className={classes.container}>
      <DetailsTaskNew />
    </div>
  );
};
